module.exports = __webpack_public_path__ + "img/58f0b74.png";